// @flow
import {trigger as edapTrigger} from './edapWrapper';
import type {SearchParamsType} from '../reducers/searchParams';

export const SEARCH_RESULT_SET_PRESENTED = 'search_result_set.presented';

export const triggerSearchResultSetPresentedEdapEvent = (
    inputParams: SearchParamsType
) => {
    const {
        adultsCount,
        childrenCount,
        petIncluded,
        arrival,
        departure
    } = inputParams;

    const data = {
        action_location: 'search',
        adult_count: adultsCount ? `${adultsCount}` : null,
        child_count: childrenCount ? `${childrenCount}` : null,
        with_pets: String(petIncluded),
        arrival,
        departure
    };

    const option = {
        delayProcessing: false
    };

    edapTrigger(SEARCH_RESULT_SET_PRESENTED, data, option);
};
